import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito conocimientos previos en psicología?',
    a: 'No. Código Oscuro está diseñado para cualquier nivel. Comenzamos desde los fundamentos y avanzamos progresivamente con ejemplos que cualquier persona puede entender y aplicar.'
  }, {
    q: '¿Esto me convierte en alguien manipulador?',
    a: 'Al contrario. Entender la psicología oscura te hace más consciente del juego social y más capaz de detectar cuando otros intentan manipularte. El conocimiento no es manipulación — la ignorancia sí te hace vulnerable.'
  }, {
    q: '¿Puedo aplicar esto en mi trabajo o negocios?',
    a: 'Sí, especialmente ahí. Las técnicas son particularmente poderosas en liderazgo, ventas, negociación y construcción de equipos. Muchos lectores reportan resultados en las primeras semanas de aplicar lo aprendido.'
  }, {
    q: '¿Cuándo recibo el material?',
    a: 'Inmediatamente después de completar tu compra. Todo es 100% digital — recibirás un correo con el acceso en menos de dos minutos. Sin esperas, sin envíos físicos.'
  }, {
    q: '¿Qué pasa si no me convence el contenido?',
    a: 'Tienes 7 días de garantía total. Si no estás satisfecho por cualquier razón, te devolvemos el dinero completo. Sin complicaciones, sin formularios, sin preguntas incómodas.'
  }, {
    q: '¿Hay evidencia real detrás de las técnicas?',
    a: 'Todo el contenido está fundamentado en investigación en psicología social y ciencias del comportamiento. No hay pensamiento mágico — solo principios comprobados aplicados de forma clara.'
  }, {
    q: '¿Funciona si soy introvertido o tímido?',
    a: 'Perfectamente. De hecho, las personas introvertidas suelen aplicar estas técnicas con mayor precisión porque son observadores naturales. La influencia no requiere extroversión — requiere conocimiento y consciencia, que es exactamente lo que encontrarás aquí.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-20 bg-negro" data-id="element-104">
      <div className="container" data-id="element-105">
        <div className="text-center max-w-[600px] mx-auto mb-8 md:mb-10" data-id="element-106">
          <div className="section-label justify-center" data-id="element-107">
            Preguntas frecuentes
          </div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-108">
            ¿Tienes dudas? Aquí respondemos todo.
          </h2>
        </div>

        <div className="max-w-[780px] mx-auto" data-id="element-109">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border-b border-[rgba(255,255,255,.08)]" data-id="element-110">
                <button className={`w-full py-[22px] flex justify-between items-center cursor-pointer text-[.95rem] font-medium transition-colors duration-200 select-none gap-3.5 text-left ${isOpen ? 'text-dorado-claro' : 'text-crema hover:text-dorado-claro'}`} onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-111">
                  <span className="flex-1" data-id="element-112">{faq.q}</span>
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-all duration-350 ease-[cubic-bezier(.4,0,.2,1)] ${isOpen ? 'rotate-45 bg-[rgba(201,151,43,.2)] text-dorado' : 'bg-[rgba(201,151,43,.1)] text-dorado'}`} data-id="element-113">
                    <Plus className="w-3.5 h-3.5" data-id="element-114" />
                  </div>
                </button>
                <AnimatePresence initial={false} data-id="element-115">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.35,
                ease: [0.4, 0, 0.2, 1]
              }} className="overflow-hidden" data-id="element-116">
                      <div className="pb-[22px] pr-[42px] text-gris-texto leading-[1.8] text-[.92rem]" data-id="element-117">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}